<template>
    <div class="register_page_wrap">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="register_form_wrapper register_form">
                        <div class="register_logo_wrap">
                            <router-link v-bind:to="'/'">
                                <img src="../../assets/images/register-logo.png">
                            </router-link>
                            <h4>Register</h4>
                        </div>
                        <form v-on:submit.prevent="register">
                            <div class="row">
                                <div class="col-md-12 form_field_block">
                                    <label class="field_label">Name</label>
                                    <input type="text" v-model="name" id="name-input" name="name" class="form-control" v-bind:class="{required : isInputValid(errors.name)}">
                                    <span class="error" v-if="errors.name">{{ getError(errors.name) }}</span>
                                </div>
                                <div class="col-md-12 form_field_block">
                                    <label class="field_label">Email Address</label>
                                    <input type="email" v-model="email" id="email-input" name="email" class="form-control" v-bind:class="{required : isInputValid(errors.email)}">
                                    <span  class="error" v-if="errors.email">{{ getError(errors.email) }}</span>
                                </div>
                                <div class="col-md-6 form_field_block">
                                    <label class="field_label">Contact Number</label>
                                    <input type="text" v-model="contact_number" id="contact_number-input" name="contact_number" class="form-control"  v-bind:class="{required : isInputValid(errors.contact_number)}">
                                    <span  class="error"  v-if="errors.contact_number">{{ getError(errors.contact_number) }}</span>
                                </div>
                                <div class="col-md-6 form_field_block">
                                    <label class="field_label">Scfhs No</label>
                                    <input type="text" v-model="scfhs_number" id="scfhs_number-input" name="scfhs_number" class="form-control"  v-bind:class="{required : isInputValid(errors.scfhs_number)}">
                                    <span class="error"  v-if="errors.scfhs_number">{{ getError(errors.scfhs_number) }}</span>
                                </div>
                                <div class="col-md-12 form_field_block">
                                    <label class="field_label">Workplace</label>
                                    <input type="text" v-model="workplace"  id="workplace-input" name="workplace" class="form-control" v-bind:class="{required : isInputValid(errors.workplace)}">
                                    <span class="error"  v-if="errors.workplace">{{ getError(errors.workplace) }}</span>
                                </div>
                                <div class="col-md-12 form_field_block">
                                    <label class="field_label">Address</label>
                                    <textarea v-model="address" id="address-input" name="address" class="form-control" v-bind:class="{required : isInputValid(errors.address)}"></textarea>
                                    <span  class="error" v-if="errors.address">{{ getError(errors.address) }}</span>
                                </div>
                                <div class="col-md-6 form_field_block">
                                    <select v-model="profession" name="profession" id="profession-input" class="form-control"   v-bind:class="{required : isInputValid(errors.profession)}">
                                        <option value="">Profession</option>
                                        <option v-for="option in profession_list" :key="option.name" :value="option.name">{{ option.name }}</option>
                                    </select>
                                    <span class="error"  v-if="errors.profession">{{ getError(errors.profession) }}</span>
                                </div>
                                <div class="col-md-6">
                                </div>
                                <div class="col-md-6 form_field_block">
                                    <label class="field_label">Password</label>
                                    <input type="password" v-model="password" name="password" class="form-control" v-bind:class="{required : isInputValid(errors.password)}">
                                    <span  class="error" v-if="errors.password">{{ getError(errors.password) }}</span>
                                </div>
                                <div class="col-md-6">
                                </div>
                                <div class="col-md-6 form_field_block">
                                    <label class="field_label">Confirm Password</label>
                                    <input type="password" v-model="password_confirmation" name="password_confirmation" class="form-control">
                                </div>
                                <div class="col-md-6">
                                </div>
                                <div class="col-md-12 text-center form_field_block">

                                    <label for="checkbox" class="checkbox_label">
                                        <input type="checkbox" v-model="remember_me" id="remember_me" name="remember_me" value="accept"  v-bind:class="{required : isInputValid(errors.remember_me)}">
                                        I agree <router-link v-bind:to="'/terms-and-conditions'">{{ $t("Terms and Conditions") }}</router-link> of the website.</label>
                                        <span  class="error" v-if="errors.remember_me">This field is required.</span>
                                </div>
                                <div class="col-md-12 text-center">
                                    <button type="submit" class="login_btn">Register</button>
                                </div>
                                <div class="col-md-12 text-center">
                                    <p>Already have an account? <router-link v-bind:to="'/login/'">Login</router-link></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import axios from 'axios'
    import router from '../../router'
    import EventBus from '../EventBus'

    export default{
        data(){
            return {
                current_locale:this.$i18n_global.locale,
                errors:[],
                name: '',
                email: '',
                address:'',
                contact_number:'',
                scfhs_number:'',
                workplace:'',
                profession:'',
                password: '',
                password_confirmation:'',
                remember_me:'',
                profession_list:[
                    { name:'Doctor' },
                    { name:'Dentist' },
                    { name:'Pharmacist' },
                    { name:'Nurse' },
                    { name:'Medical Science Specialist' },
                    { name:'Technician' }
                ]
            }
        },

        methods:{
            register() {
                axios.post(this.$hostname+'/api/register',{
                        name: this.name,
                        email: this.email,
                        address:this.address,
                        contact_number:this.contact_number,
                        scfhs_number:this.scfhs_number,
                        workplace:this.workplace,
                        profession:this.profession,
                        password: this.password,
                        password_confirmation:this.password_confirmation,
                        remember_me:this.remember_me
                    })
                    .then((res) => {
                        router.push({name: 'Login',query: { success: true }})
                    })
                    .catch((error) => {
                        this.errors = error.response.data;
                        return false;
                    })
            }

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Auth/Register.vue